import { Button, Form, Image, Input, Toast } from 'antd-mobile';
import { LockOutline, UserOutline } from 'antd-mobile-icons';
import React from 'react';
import '../App.css';
// 引入背景图
import axios from 'axios';
import backgroundImage from '../assets/background.png';
// import logo from '../assets/logo.png'; // 假设有logo图片
import { login } from '../componet/service';
import '../styles/LoginPage.css'; // 添加专用样式文件

const LoginPage = ({ onLogin }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // ... 现有代码保持不变 ...
    login(values.username, values.password).then(res => {
      console.log('提交登录:', values);
      if (res.code === 0) {
        Toast.show({
          icon: 'success',
          content: '登录成功'
        });
        localStorage.setItem("token", res.data.token);
        axios.defaults.headers.common["token"] = localStorage.token;
        onLogin?.();
      } else {
        Toast.show({
          icon: 'fail',
          content: res.msg
        });
      }

    }).catch(err => {
      Toast.show({
        icon: 'fail',
        content: '用户名或密码错误'
      });
    })
  };

  return (
    <div className="login-container">
      {/* 背景图 */}
      <Image src={backgroundImage} className="login-background" fit='cover' />

      {/* 登录表单区域 */}
      <div className="login-content">
        <div className="login-header">
          {/* <Image src={logo} width={80} height={80} className="login-logo" /> */}
          <h1 className="login-title">检测设备管理系统</h1>
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          layout="horizontal"
          className="login-form"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              placeholder="请输入用户名"
              clearable
              className="login-input"
              prefix={<UserOutline className="login-icon" />}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input
              type="password"
              placeholder="请输入密码"
              clearable
              className="login-input"
              prefix={<LockOutline className="login-icon" />}
            />
          </Form.Item>

          <Form.Item>
            <Button
              block
              type="submit"
              color="primary"
              size="large"
              className="login-button"
            >
              登录系统
            </Button>
          </Form.Item>
        </Form>

        <div className="login-footer">
          © 2025 检测设备管理系统
        </div>
      </div>
    </div>
  );
};

export default LoginPage;